
import { supabase } from '@/lib/supabase';
import { handleError, ErrorSeverity } from '@/utils/errorHandler';

/**
 * Fetches organization data
 */
export async function fetchOrganizationData(organizationId: string) {
  try {
    const { data, error } = await supabase
      .from('organizations')
      .select('*')
      .eq('id', organizationId)
      .single();
      
    if (error) throw error;
    return data;
  } catch (error) {
    handleError(
      error,
      `Error fetching organization data for ID: ${organizationId}`,
      ErrorSeverity.WARNING,
      { operation: 'fetchOrganizationData', organizationId },
      false
    );
    return null;
  }
}
